import { Component, OnInit } from '@angular/core';
import { Log } from 'src/app/_models/log';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LoadingService } from 'src/app/_services/local/loading.service';
import { ToasterService } from 'angular2-toaster';
import { LogService } from 'src/app/_services/madu-api/log.service';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss']
})
export class LogComponent implements OnInit {

  public LogList: Log[];

  public bsConfig: Partial<BsDatepickerConfig>;
  public bsDateIni: Date;
  public bsDateFim: Date;

  constructor(private loadingService: LoadingService,
    private toasterService: ToasterService,
    private logService: LogService) {

      this.bsConfig = { dateInputFormat: 'DD/MM/YYYY' };
      this.bsDateIni = new Date();
      this.bsDateFim = new Date();
     }

  ngOnInit(): void {
    this.getLog();
  }

  getLog() {
    this.loadingService.showLoading(true);
    this.logService.getLogPorData(this.bsDateIni, this.bsDateFim)
      .subscribe(
        result => {
          this.LogList = result;
          this.loadingService.showLoading(false);
        },
        error => { this.onError(error); }
      )
  }

  private onError(error: any) {
    this.loadingService.clearShowLoading();
    console.log(error);
    this.toasterService.pop('error', 'Opa :(', 'Algo deu errado!');
  }
}
